import { useEffect, useRef, type ReactNode } from 'react'
import { clsx } from 'clsx'

interface ModalProps {
  title: string
  children: ReactNode
  wide?: boolean
}

export function Modal({ title, children, wide }: ModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (!dialog.open) dialog.showModal()
    // El modal solo debe poder cerrarse con los botones propios del formulario
    // (Guardar/Cancelar) -- Escape se neutraliza a proposito (preventDefault sin
    // llamar a onClose), y no hay handler de clic en el backdrop.
    const handleCancel = (e: Event) => {
      e.preventDefault()
    }
    dialog.addEventListener('cancel', handleCancel)
    return () => dialog.removeEventListener('cancel', handleCancel)
  }, [])

  return (
    <dialog
      ref={dialogRef}
      className={clsx(
        'fixed inset-0 m-auto h-fit max-h-[90vh] max-w-[92vw] overflow-y-auto rounded-2xl border border-line bg-panel p-6 text-text backdrop:bg-black/70',
        wide ? 'w-[900px]' : 'w-[400px]',
      )}
    >
      <h2 className="mb-2.5 text-lg font-extrabold">{title}</h2>
      {children}
    </dialog>
  )
}
